module.exports = __webpack_public_path__ + "static/media/9DESA18.f04d5fa8.jpg";